import { render } from "./Index.vue?vue&type=template&id=7ae530fa&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=7ae530fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ae530fa"

export default script